import React, { useContext, FunctionComponent } from 'react';
import { AlertBox } from '@doveit/lego';
import FilterableListContext from '../AsyncSuggestionListContext';
import SelectableList from '../../selectable-list/SelectableList';

const DEFAULT_NO_ITEMS_MESSAGE = 'Nessun risultato';

export interface SuggestionListProps {
  title?: string,
  noItemsMessage?: string,
}

const SuggestionList: FunctionComponent<SuggestionListProps> = ({
  title,
  noItemsMessage,
}) => {
  const {
    searchTerm,
    items,
    onItemSelect,
    error,
    minFilteringCharacters,
  } = useContext(FilterableListContext);

  return (
    <>
      {error && <AlertBox message="Si è verificato un errore durante la ricerca" />}
      {!error && (searchTerm || '').length >= minFilteringCharacters && (
        <SelectableList
          title={title}
          items={items || []}
          noItemsMessage={noItemsMessage || DEFAULT_NO_ITEMS_MESSAGE}
          onItemClick={onItemSelect}
        />
      )}
    </>
  );
};

export default SuggestionList;
